"use client";

import Link from "next/link";
import styles from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Links */}
        <div className={styles.linksContainer}>
          <Link href="/" className={styles.footerLink}>
            Home
          </Link>
          <Link href="/courses" className={styles.footerLink}>
            Courses
          </Link>
          <Link href="/articles" className={styles.footerLink}>
            Articles
          </Link>
          <Link href="/privacy-policy" className={styles.footerLink}>
            Privacy Policy
          </Link>
        </div>

        {/* Copyright */}
        <div className={styles.copyrightContainer}>
          <p className={styles.copyrightText}>
            &copy; 2020-{new Date().getFullYear()} Applied Language Institute EIRL
          </p>
          <p className={styles.copyrightText}>
            Designed by{" "}
            <a
              href="https://www.atomicwebservices.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.designerLink}
            >
              Atomic Web Services
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}